import SectionTitle from "../../../Shared/SectionTitle/SectionTitle.component";
import {
  Background,
  BenefitsItem,
  Container,
  Description,
  ItemPhoto,
  SubTitle,
  TextSectionWrapper,
  TitleWrapper,
  BenefitsRow,
  SpaceBetween,
} from "./Benefits.styles";

export default function Benefits() {
  return (
    <>
      <Container id="benefits">
        <Background />
        <TitleWrapper>
          <SectionTitle text="Benefícios" />
        </TitleWrapper>

        <BenefitsRow>
          <BenefitsItem>
            <ItemPhoto src="images/benefits/agile.png" />
            <TextSectionWrapper>
              <SubTitle>Agilidade no seu processo</SubTitle>
              <Description>Faça a vistoria do seu carro em poucos minutos, unindo o direcionamento do aplicativo e facilidade do uso do celular, todo o processo é concluído em instantes.</Description>
            </TextSectionWrapper>
          </BenefitsItem>
          <SpaceBetween />
          <BenefitsItem>
            <ItemPhoto src="images/benefits/payment.png" />
            <TextSectionWrapper>
              <SubTitle>Pague como preferir</SubTitle>
              <Description>Sua liberdade é nossa maior preocupação, escolha o melhor método de pagamento para você e inicie seu processo de vistoria em poucos minutos.</Description>
            </TextSectionWrapper>
          </BenefitsItem>
        </BenefitsRow>
        <BenefitsRow>
          <BenefitsItem>
            <ItemPhoto src="images/benefits/inspection.png" />
            <TextSectionWrapper>
              <SubTitle>Vistoria de qualquer lugar</SubTitle>
              <Description>Faça sua vistoria onde estiver: sem agendamento e sem intermédio de terceiros, o nosso processo só precisa de você e do seu celular.</Description>
            </TextSectionWrapper>
          </BenefitsItem>
          <SpaceBetween />
          <BenefitsItem>
            <ItemPhoto src="images/benefits/mobile.png" />
            <TextSectionWrapper>
              <SubTitle>Experiência descomplicada</SubTitle>
              <Description>Não precisa baixar aplicativos, o nosso WebApp é disponível para todos os modelos de celulares, funcionando no próprio navegador do aparelho.</Description>
            </TextSectionWrapper>
          </BenefitsItem>
        </BenefitsRow>
      </Container>
    </>
  );
}
